<template>
<div class="white-box recharge-succ">
  <p class="succ-icon"><i class="el-icon-circle-check"></i></p>
  <p class="succ-tips">提交成功，等待财务审核</p>
  <p class="succ-sub-tips">审核完成后，会通过短信通知您，短信将发到您登陆本系统的手机号</p>
  <p class="succ-sub-tips">您还可以，点此<span @click="go('rechargelist')">查看充值申请</span> 或 <span @click="go('recharge')">继续发起充值申请</span></p>
</div>
</template>
<script type="text/javascript">
export default {
  data () {
    return {

    }
  },
  methods: {
    go (route) {
      this.$router.push(route)
      if(route === 'recharge') {
        this.$parent.$data.succ = false
        this.$parent.$data.ruleForm = {
          amount: '', //充值金额  
          bankAccountNumber: '', //银行账户编号  
          bankAccountName: '', //银行账户名称  
          voucher: '', //凭据 
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .recharge-succ {
    text-align: center;
    padding-top: 100px;
    font-family: 'MicrosoftYaHei';
    height: calc(100vh - 120px);
    .succ-icon {
      color: #12ce65;
      font-size: 60px;
    }
    .succ-tips {      
      font-size: 20px;
      color: #333;
      margin-bottom: 10px;
    }
    .succ-sub-tips {
      font-size: 14px;
      color: #666;
      margin-bottom: 30px;
      span {
        color: #419bf9;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// rechargeSuccess.vue?dd35c492